export default "__VITE_ASSET__cc32f79b__"